import { createSlice } from "@reduxjs/toolkit";

interface TrainingState {
    info: any | null;
    trainingId: string | null;
    truck_stop_pending_count: number | null;
    tier_upgrade_pending_count: number | null;
    requestcallback_count: number | null;
    driver_pending_count: number | null;
    pending_rewards_from_truck_stop_owner: number | null;
    review_flag_pending_count: number | null;
    reported_issue_pending_count: number | null;
}

const initialState: TrainingState = {
    info: null,
    trainingId: null,
    truck_stop_pending_count: null,
    tier_upgrade_pending_count: null,
    requestcallback_count: null,
    driver_pending_count: null,
    pending_rewards_from_truck_stop_owner: null,
    review_flag_pending_count: null,
    reported_issue_pending_count: null
};

const trainingSlice = createSlice({
    name: "training",
    initialState,
    reducers: {
        setTrainingInfo: (state, action) => {
            state.info = action.payload;
        },
        setGlobalTrainingId: (state, action) => {
            state.trainingId = action.payload;
        },
        setTruckStopPendingCount: (state, action) => {
            state.truck_stop_pending_count = action.payload;
        },
        setTierUpgradePendingCount: (state, action) => {
            state.tier_upgrade_pending_count = action.payload;
        },
        setRequestCallbackCount: (state, action) => {
            state.requestcallback_count = action.payload;
        },
        setDriverPendingCount: (state, action) => {
            state.driver_pending_count = action.payload;
        },
        setPendingRewardsFromTruckStopOwner: (state, action) => {
            state.pending_rewards_from_truck_stop_owner = action.payload;
        },
        setReviewFlagCount: (state, action) => {
            state.review_flag_pending_count = action.payload;
        },
        setReportedIssueCount: (state, action) => {
            state.reported_issue_pending_count = action.payload;
        },
        clearTrainingInfo: (state) => {
            state.info = null;
            state.trainingId = null;
            state.truck_stop_pending_count = null;
            state.tier_upgrade_pending_count = null;
            state.requestcallback_count = null;
            state.driver_pending_count = null;
            state.pending_rewards_from_truck_stop_owner = null;
            state.review_flag_pending_count = null;
            state.reported_issue_pending_count = null;
        },
    },
});

export const { setTrainingInfo, setGlobalTrainingId, setTruckStopPendingCount, setDriverPendingCount, setRequestCallbackCount, setReviewFlagCount, setTierUpgradePendingCount, setReportedIssueCount, setPendingRewardsFromTruckStopOwner, clearTrainingInfo } = trainingSlice.actions;
export default trainingSlice.reducer;
